/**!
 * Created by Leonardo Cheslacki on 06/05/2024.
 *
 * MIT License
 *
 * Copyright (c) 2024 cheslacki
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.

 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

import AnimateController from './../AnimateController';

class StageController extends AnimateController {
    constructor() {
        super();
    };

    $functionsStage = {
        /**
         *
         * @param event
         */
        handle: function (event) {

        }
    };

    /**
     *
     * @param element
     * @param attributes
     * @param content
     * @param $document
     * @returns {*|null}
     */
    createElement = (element, attributes, content, $document = document) => {
        if (element.constructor.name !== 'HTMLUnknownElement') {
            this.isObjectIf(attributes) && this.setAttributes(element, attributes);

            if (this.isArrayIf(content)) {
                element.append(...content);
            } else {
                !this.isEmpty(content) && element.append($document.createTextNode(content));
            }

            return element;
        } else {
            return null;
        }
    };

    /**
     *
     * @param tag
     * @param attributes
     * @param content
     * @param $document
     * @returns {*|null}
     */
    createElementSVG = (tag, attributes = {}, content = null, $document = document) => {
        let element = $document.createElementNS('http://www.w3.org/2000/svg', tag);

        return this.createElement(element, attributes, content, $document);
    };

    /**
     *
     * @param tag
     * @param attributes
     * @param content
     * @param $document
     * @returns {*|null}
     */
    createElementHtml = (tag, attributes = {}, content = null, $document = document) => {
        let element = $document.createElement(tag.toLowerCase());

        return this.createElement(element, attributes, content, $document);
    };
}

export default StageController;
